"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const Toast_1 = __importDefault(require("@/components/Toast"));
const style_1 = require("@/pages/ApprovedFeedstock/style");
const constants_1 = require("./constants");
const selectors_1 = require("@/store/ducks/ports/selectors");
const listPortsUseCase_1 = __importDefault(require("@/useCases/ports/listPortsUseCase"));
const listProductsUseCase_1 = require("@/useCases/products/listProductsUseCase");
const selectors_2 = require("@/store/ducks/products/selectors");
const selectors_3 = require("@/store/ducks/approvedFeedstocks/selectors");
const approvedFeedstocks_1 = require("@/useCases/approvedFeedstocks");
const fi_1 = require("react-icons/fi");
const approvedFeedstocks_2 = require("@/store/ducks/approvedFeedstocks");
const StatusIcon_1 = __importDefault(require("./components/atoms/StatusIcon"));
const ActionButtons_1 = __importDefault(require("./components/molecules/ActionButtons"));
const StatusSelectInput_1 = __importDefault(require("./components/atoms/StatusSelectInput"));
const ActionFooter_1 = __importDefault(require("./components/molecules/ActionFooter"));
const PageHeader_1 = __importDefault(require("@/components/PageHeader"));
const ApprovedFeedstockContext = (0, react_1.createContext)({
    showCreateFeedstockRow: false,
    setShowCreateFeedstockRow: undefined,
    editableFeedstockId: undefined,
    setEditableFeedstockId: undefined,
    form: undefined,
    setShowDeleteWarningModal: undefined,
    setDeleteFeedstockId: undefined
});
// TODO: CRIAR NOVO HEADER
const ApprovedFeedstockHeader = () => {
    return (react_1.default.createElement(PageHeader_1.default, { title: "Approved Feedstock" }));
};
const ApprovedFeedstockTableRow = ({ feedstock, onEdit, onDelete }) => {
    const getStatusBySystem = (feedstock, siteName, systemName) => {
        const selectedSystem = feedstock.systems.find((aprovedFeedstockSystem) => {
            const { system } = aprovedFeedstockSystem;
            return system.site?.name === siteName && system?.name === systemName;
        });
        if (selectedSystem) {
            return selectedSystem;
        }
    };
    const feedstockPort = `${feedstock.port.country.abbreviation} ${feedstock.port.name}`;
    return (react_1.default.createElement(style_1.StyledTableRow, null,
        react_1.default.createElement(material_1.TableCell, null, feedstockPort),
        react_1.default.createElement(material_1.TableCell, null, feedstock.product.name),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusIcon_1.default, { status: getStatusBySystem(feedstock, "Q1BA", "UO1")?.status })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusIcon_1.default, { status: getStatusBySystem(feedstock, "Q1BA", "Reformer")?.status })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusIcon_1.default, { status: getStatusBySystem(feedstock, "Q2RS", "UO1")?.status })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(ActionButtons_1.default, { onEdit: onEdit, onDelete: onDelete }))));
};
const ApprovedFeedstockEditableTableRow = ({ form }) => {
    const portsOptions = (0, react_redux_1.useSelector)(selectors_1.portsOptionsSelector);
    const productsOptions = (0, react_redux_1.useSelector)(selectors_2.productOptionsSelector);
    //TODO: CHECK RENDER INPUT
    const customInputLabelProps = {
        disableAnimation: true,
        shrink: false,
        focused: false,
    };
    const customInputProps = {
        startAdornment: (react_1.default.createElement(fi_1.FiSearch, null)),
        sx: {
            backgroundColor: "white",
            minHeight: "48px",
            borderRadius: "6px",
        }
    };
    return (react_1.default.createElement(style_1.StyledEditableTableRow, null,
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(material_1.Autocomplete, { onBlur: form?.handleBlur, renderInput: (params) => react_1.default.createElement(material_1.TextField, { ...params, InputLabelProps: {
                        ...params.InputLabelProps,
                        ...customInputLabelProps
                    }, InputProps: {
                        ...params.InputProps,
                        ...customInputProps,
                    }, placeholder: "Search for a port" }), id: "portId", options: portsOptions, onChange: (_, value) => form?.setFieldValue("portId", value), value: form?.values.portId })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(material_1.Autocomplete, { onBlur: form?.handleBlur, renderInput: (params) => react_1.default.createElement(material_1.TextField, { ...params, InputLabelProps: {
                        ...params.InputLabelProps,
                        ...customInputLabelProps
                    }, InputProps: {
                        ...params.InputProps,
                        ...customInputProps,
                    }, placeholder: "Search for a product" }), id: "productId", options: productsOptions, onChange: (_, value) => form?.setFieldValue("productId", value), value: form?.values.productId })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusSelectInput_1.default, { id: "q1BaGlobal", form: form })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusSelectInput_1.default, { id: "q1BaReforma", form: form })),
        react_1.default.createElement(material_1.TableCell, null,
            react_1.default.createElement(StatusSelectInput_1.default, { id: "q2RsGlobal", form: form })),
        react_1.default.createElement(material_1.TableCell, null)));
};
const ApprovedFeedstockTableSkeleton = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null, [...Array(10)].map((_, index) => (react_1.default.createElement(material_1.TableRow, { key: index }, [...Array(constants_1.TABLE_HEAD_COLUMNS.length)].map((_, index) => (react_1.default.createElement(material_1.TableCell, { key: index },
        react_1.default.createElement(material_1.Skeleton, { variant: "rectangular", height: 14 })))))))));
};
const ApprovedFeedstockTable = () => {
    const { showCreateFeedstockRow, setShowCreateFeedstockRow, editableFeedstockId, setEditableFeedstockId, form, setShowDeleteWarningModal, setDeleteFeedstockId } = (0, react_1.useContext)(ApprovedFeedstockContext);
    const dispatch = (0, react_redux_1.useDispatch)();
    const approvedFeedstockList = (0, react_redux_1.useSelector)(selectors_3.approvedFeedstocksSelector);
    const approvedFeedstockLoading = (0, react_redux_1.useSelector)(selectors_3.approvedFeedstocksLoadingSelector);
    const portsOptions = (0, react_redux_1.useSelector)(selectors_1.portsOptionsSelector);
    const productsOptions = (0, react_redux_1.useSelector)(selectors_2.productOptionsSelector);
    const handleDiscard = () => {
        form?.resetForm();
        setShowCreateFeedstockRow?.(false);
    };
    const renderCreateFeedstockRow = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ApprovedFeedstockEditableTableRow, { form: form }),
            react_1.default.createElement(ActionFooter_1.default, { onDiscard: handleDiscard, onSave: () => form?.submitForm() })));
    };
    const onChangeToEditFeedstock = (feedstock) => {
        setShowCreateFeedstockRow?.(false);
        form?.setFieldValue("portId", feedstock.port.name);
        form?.setFieldValue("productId", feedstock.product.name);
        form?.setFieldValue("q1BaGlobal", feedstock.systems[0].status);
        form?.setFieldValue("q1BaReforma", feedstock.systems[1].status);
        form?.setFieldValue("q2RsGlobal", feedstock.systems[2].status);
        setEditableFeedstockId?.(feedstock.id);
    };
    const onEditFeedstock = (feedstockId) => {
        const fieldsTouched = form?.touched;
        const payload = {};
        if (fieldsTouched?.portId) {
            payload.portId = portsOptions.find((option) => option.label === form?.values.portId)?.value;
        }
        if (fieldsTouched?.productId) {
            payload.productId = productsOptions.find((option) => option.label === form?.values.productId)?.value;
        }
        if (fieldsTouched?.q1BaGlobal) {
            payload.systems = [];
            payload.systems?.push({ systemId: "6e6f457c-c879-43de-8843-2f26504121f7", status: form?.values.q1BaGlobal });
        }
        if (fieldsTouched?.q1BaReforma) {
            if (!payload.systems) {
                payload.systems = [];
            }
            payload.systems?.push({ systemId: "d697ba54-b517-45b4-88aa-e395fc0dbe5b", status: form?.values.q1BaReforma });
        }
        if (fieldsTouched?.q2RsGlobal) {
            if (!payload.systems) {
                payload.systems = [];
            }
            payload.systems?.push({ systemId: "4aec675b-d6ab-4c8e-8373-6937ca529b08", status: form?.values.q2RsGlobal });
        }
        dispatch((0, approvedFeedstocks_1.editApprovedFeedstockUseCase)(feedstockId, payload));
    };
    const onDeleteFeedstock = (feedstockId) => {
        setShowDeleteWarningModal?.(true);
        setDeleteFeedstockId?.(feedstockId);
    };
    const handleDiscardEdit = () => {
        form?.resetForm();
        setEditableFeedstockId?.(undefined);
    };
    return (react_1.default.createElement(material_1.TableContainer, { component: style_1.TableWrapper, sx: { marginBottom: "70px" } },
        react_1.default.createElement(material_1.Table, null,
            react_1.default.createElement(style_1.DarkTableHead, null,
                react_1.default.createElement(material_1.TableRow, null, constants_1.TABLE_HEAD_COLUMNS.map((header) => react_1.default.createElement(material_1.TableCell, { key: header.label, width: header.width }, header.label)))),
            react_1.default.createElement(material_1.TableBody, null, approvedFeedstockLoading ?
                react_1.default.createElement(ApprovedFeedstockTableSkeleton, null) :
                (react_1.default.createElement(react_1.default.Fragment, null,
                    showCreateFeedstockRow && renderCreateFeedstockRow(),
                    approvedFeedstockList.map((feedstock) => {
                        if (editableFeedstockId === feedstock.id) {
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(ApprovedFeedstockEditableTableRow, { key: feedstock.id, form: form }),
                                react_1.default.createElement(ActionFooter_1.default, { onDiscard: handleDiscardEdit, onSave: () => onEditFeedstock(feedstock.id) })));
                        }
                        return (react_1.default.createElement(ApprovedFeedstockTableRow, { key: feedstock.id, feedstock: feedstock, onEdit: () => onChangeToEditFeedstock(feedstock), onDelete: () => onDeleteFeedstock(feedstock.id) }));
                    })))))));
};
const ApprovedFeedstockContent = () => {
    const { setShowCreateFeedstockRow, setEditableFeedstockId, form } = (0, react_1.useContext)(ApprovedFeedstockContext);
    const handleNewFeedstockButton = () => {
        form?.resetForm();
        setShowCreateFeedstockRow?.(true);
        setEditableFeedstockId?.(undefined);
    };
    return (react_1.default.createElement(material_1.Container, { maxWidth: "lg" },
        react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "space-between", mb: "12px" },
            react_1.default.createElement(material_1.Button, { variant: "outlined", disabled: true, startIcon: react_1.default.createElement(fi_1.FiFilter, null) }, "Filter"),
            react_1.default.createElement(material_1.Button, { onClick: () => handleNewFeedstockButton(), startIcon: react_1.default.createElement(fi_1.FiPlus, null), variant: "contained" }, "Add new feedstock")),
        react_1.default.createElement(ApprovedFeedstockTable, null)));
};
function ApprovedFeedstock() {
    const [showCreateFeedstockRow, setShowCreateFeedstockRow] = (0, react_1.useState)(false);
    const [editableFeedstockId, setEditableFeedstockId] = (0, react_1.useState)(undefined);
    const [deleteFeedstockId, setDeleteFeedstockId] = (0, react_1.useState)(undefined);
    const [showDeleteWarningModal, setShowDeleteWarningModal] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const approvedFeedstocksToastStatus = (0, react_redux_1.useSelector)(selectors_3.approvedFeedstocksToastStatusSelector);
    const { isOpen, status, message } = approvedFeedstocksToastStatus;
    (0, react_1.useEffect)(() => {
        dispatch((0, approvedFeedstocks_1.getApprovedFeedstocksUseCase)());
        dispatch((0, listPortsUseCase_1.default)());
        dispatch((0, listProductsUseCase_1.listProducts)());
    }, []);
    const submittableRowForm = (values) => {
        const q1BaGlobal = values.q1BaGlobal;
        const q1BaReforma = values.q1BaReforma;
        const q2RsGlobal = values.q2RsGlobal;
        const payload = {
            portId: values.portId.value,
            productId: values.productId.value,
            systems: [
                {
                    systemId: "6e6f457c-c879-43de-8843-2f26504121f7",
                    status: q1BaGlobal
                },
                {
                    systemId: "d697ba54-b517-45b4-88aa-e395fc0dbe5b",
                    status: q1BaReforma
                },
                {
                    systemId: "4aec675b-d6ab-4c8e-8373-6937ca529b08",
                    status: q2RsGlobal
                }
            ]
        };
        dispatch((0, approvedFeedstocks_1.createApprovedFeedstockUseCase)(payload));
        setShowCreateFeedstockRow?.(false);
    };
    const tableRowForm = (0, formik_1.useFormik)({
        initialValues: {
            portId: { label: "", value: "" },
            productId: { label: "", value: "" },
            q1BaGlobal: "",
            q1BaReforma: "",
            q2RsGlobal: "",
        },
        onSubmit: submittableRowForm,
    });
    // const handleFilter = () => {
    //   setFilterOpen(!filterOpen);
    // };
    const onCloseToast = react_1.default.useCallback((event, reason) => {
        dispatch((0, approvedFeedstocks_2.closeApprovedFeedstockToastReducer)());
    }, [approvedFeedstocks_2.closeApprovedFeedstockToastReducer, dispatch]);
    const confirmDeleteFeedstock = () => {
        if (deleteFeedstockId) {
            dispatch((0, approvedFeedstocks_1.deleteApprovedFeedstockUseCase)(deleteFeedstockId));
            setShowDeleteWarningModal(false);
        }
    };
    const contextValue = {
        showCreateFeedstockRow,
        setShowCreateFeedstockRow,
        editableFeedstockId,
        setEditableFeedstockId,
        form: tableRowForm,
        setShowDeleteWarningModal,
        setDeleteFeedstockId
    };
    return (react_1.default.createElement(ApprovedFeedstockContext.Provider, { value: contextValue },
        react_1.default.createElement(ApprovedFeedstockHeader, null),
        react_1.default.createElement(ApprovedFeedstockContent, null),
        react_1.default.createElement(material_1.Dialog, { open: showDeleteWarningModal || false, PaperComponent: style_1.StyledBox, onClose: () => setShowDeleteWarningModal(false) },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(fi_1.FiAlertTriangle, { size: 60 }),
                react_1.default.createElement(material_1.Typography, { variant: "h3", mt: "8px", component: "h2" }, "Are you sure?"),
                react_1.default.createElement(material_1.Typography, { textAlign: "center", sx: { mt: 2 } }, "You are about to REMOVE this feedstock. This action cannot be undone. Are you sure you want to proceed?"),
                react_1.default.createElement(material_1.Stack, { direction: "row", mt: "40px", width: "100%", spacing: "8px", justifyContent: "end" },
                    react_1.default.createElement(material_1.Button, { onClick: () => setShowDeleteWarningModal(false), startIcon: react_1.default.createElement(fi_1.FiArrowLeft, null), variant: "outlined" }, "Go back"),
                    react_1.default.createElement(material_1.Button, { endIcon: react_1.default.createElement(fi_1.FiTrash, null), variant: "contained", onClick: () => confirmDeleteFeedstock() }, "Remove Feedstock")))),
        react_1.default.createElement(Toast_1.default, { isOpen: isOpen, severity: status || "success", message: message || "", onClose: onCloseToast, closeText: "X" })));
}
exports.default = ApprovedFeedstock;
